<template>
  <div id="radial-chart">

      <apexchart 
        type=radialBar 
        width=150
        :options="plotOptions" 
        :series="series" />

    </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'

export default {
  name: 'radial-chart',
    props: ['label', 'num', 'color', 'totalOS'],
    data: () => ({
        dataReady: false,
        series: [10],
        plotOptions: {
            labels: [''],
            colors: [''],
            radialBar: {
                hollow: {
                    size: '100%',
                }
            },
        },
    }),
    components: {
        apexchart: VueApexCharts,
    },
    created: function() {
        this.series = [((this.num / this.totalOS) * 100).toFixed(0)];
        this.plotOptions.colors = [this.color]
        this.plotOptions.labels = [this.label];
        this.dataReady = true;
    }
}
</script>
<style scoped>
    #radial-chart {
        margin: 1rem;
        border-radius: 15px;
        box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);
        background: white;
    }
</style>